import { useId } from '@/hooks/useId';
import { useTab } from '@/hooks/useTab';
import { useToggle } from '@/hooks/useToggle';
import TileShell from '@/components/TileShell';
import FileViewer from '@/components/viewers/FileViewer';
import CollectionCard from '../CollectionCard';
import type { CollectionTab } from '../CollectionCard/types';
import { classes } from './utils';

export type FileTileProps = {
  baseCollectionId: number;
  initialFileId?: number;
  compact?: boolean;
  onClose: () => void;
};

export default function FileTile({
  baseCollectionId,
  initialFileId,
  compact = false,
  onClose,
}: FileTileProps) {
  const [activeFileId, setActiveFileId] = useId(initialFileId);
  const [activeTab, setActiveTab] = useTab<CollectionTab>('files');
  const [isSidebarOpen, toggleSidebar] = useToggle(true);

  return (
    <TileShell
      compact={compact}
      hasActiveFile={!!activeFileId}
      isSidebarOpen={isSidebarOpen}
      sidebarWide={activeTab === 'notes'}
      sidebar={
        <CollectionCard
          condensed={!!activeFileId && compact}
          baseCollectionId={baseCollectionId}
          activeFileId={activeFileId}
          onChangeTab={setActiveTab}
          onHideSidebar={
            !!activeFileId && !compact && isSidebarOpen
              ? () => toggleSidebar(false)
              : undefined
          }
          onOpenFile={setActiveFileId}
          onClose={onClose}
        />
      }
      onShowSidebar={() => toggleSidebar(true)}>
      {!!activeFileId && (
        <FileViewer
          className={classes.viewer}
          fileId={activeFileId}
          onClose={onClose}
        />
      )}
    </TileShell>
  );
}
